import numeral from 'numeral';

export const formatCurrency = (number) => `${numeral(number).format('0,0')}₪`;

export const getWeboConfig = (key) =>
  (window.WEBO_CONFIG[key] || {}).value || false;

export function isProductHasAgreement(product) {
  return product?.agreement && product?.agreement !== '0';
}
